// Complete Simplified Chinese interface dictionary.
// Keys are stable message identifiers; values are the only Chinese text rendered by t().
export default {
  独立单边论证: '独立单边论证',
  删除属性: '删除属性',
  '属性已从当前文章删除。': '属性已从当前文章删除。',
  '仅删除当前文章的此属性、提取结果及相关 Motif 条件，其他文章不受影响。':
    '仅删除当前文章的此属性、提取结果及相关论证模式条件，其他文章不受影响。',
  尚无段落摘要: '尚无段落摘要',
  '展开为 Unit': '展开为 Unit',
  折叠为段落: '折叠为段落',
  类型: '类型',
  '脚本提取时间、地点和人物': '脚本提取时间、地点和人物',
  生成单元短标签: '生成单元短标签',
  生成段落摘要: '生成段落摘要',
  按完整句子划分论证单元: '按完整句子划分论证单元',
  判断节点类型: '判断节点类型',
  判断段落关系: '判断段落关系',
  判断论证单元关系: '判断论证单元关系',
  '计算单元 Embedding': '计算单元向量',
  '匹配 Motif': '匹配论证模式',
  构建初始图: '构建初始图',
  '更新 Schema': '更新分类体系',
  '更新 Facet': '更新分析切面',
  '更新 Motif': '更新论证模式',
  '拆分 Markdown，构建段落图与段内单元图，提取实体及向量':
    '拆分标记文档，构建段落图与段内单元图，提取实体及向量',
  按变更的节点和关系定义更新受影响数据: '按变更的节点和关系定义更新受影响数据',
  '只更新新增或修改的属性列，并汇总到段落': '只更新新增或修改的属性列，并汇总到段落',
  匹配新增或修改的子图模式: '匹配新增或修改的子图模式',
  焦点相关性: '焦点相关性',
  '正在计算相关性…': '正在计算相关性…',
  相关性阈值: '相关性阈值',
  '已选 {count} 个候选单元': '已选 {count} 个候选单元',
  分析焦点关系: '分析焦点关系',
  查看候选及分数: '查看候选及分数',
  提取方式: '提取方式',
  本地实体脚本: '本地实体脚本',
  'Facet Agent · 按定义提取属性': '智能体按定义提取属性',
  '词表脚本 · 精确匹配': '词表脚本 · 精确匹配',
  多个词以逗号分隔: '多个词以逗号分隔',
  '添加后提取各单元的属性并汇总到段落。': '添加后提取各单元的属性并汇总到段落。',
  '保存后点击“更新 Facet”应用修改。': '保存后点击“更新分析切面”应用修改。',
  '属性值，留空表示存在该属性': '属性值，留空表示存在该属性',
  '关系 {0} 类型': '关系 {0} 类型',
  请先构建初始图: '请先构建初始图',
  '定义已保存，点击对应更新按钮应用。': '定义已保存，点击对应更新按钮应用。',
  '当前文档已重置，保留当前 Schema。现在可重新构建初始图。':
    '当前文档已重置，保留当前分类体系。现在可重新构建初始图。',
  '属性已添加，构建初始图后点击“更新 Facet”提取。': '属性已添加，构建初始图后点击“更新分析切面”提取。',
  增加关系: '增加关系',
  方向: '方向',
  关联单元: '关联单元',
  选择论证单元: '选择论证单元',
  '当前单元 → 对方': '当前单元 → 对方',
  '对方 → 当前单元': '对方 → 当前单元',
  关系说明: '关系说明',
  关系说明与备注: '关系说明与备注',
  '可连接同段或其他段落的论证单元；所有修改在保存标注后生效。':
    '可连接同段或其他段落的论证单元；所有修改在保存标注后生效。',
  '暂无关联关系。': '暂无关联关系。',
  '关系必须连接当前单元与另一个论证单元。': '关系必须连接当前单元与另一个论证单元。',
  '关联单元不存在或已被当前句子范围合并，请修改或删除对应关系。':
    '关联单元不存在或已被当前句子范围合并，请修改或删除对应关系。',
  '请选择有效的关系类型。': '请选择有效的关系类型。',
  '关系编号重复。': '关系编号重复。',
  '补充分析未完成，已有节点仍可查看。': '补充分析未完成，已有节点仍可查看。',
  '正在补充摘要与段内关系…': '正在补充摘要与段内关系…',
  '本地后端响应超时，请检查后端终端和任务状态。': '本地后端响应超时，请检查后端终端和任务状态。',
  '无法读取本地后端响应。请检查后端终端；更新代码后请重启 npm run backend。':
    '无法读取本地后端响应。请检查后端终端；更新代码后请重启后端服务。',
  '后端处理请求失败，请查看后端终端；若刚更新代码，请重启 npm run backend。':
    '后端处理请求失败，请查看后端终端；若刚更新代码，请重启后端服务。',
  '后端返回格式无效，请确认本地 API 服务地址。': '后端返回格式无效，请确认本地接口服务地址。',
  '每类最多检索 250 个匹配，可分批显示。': '每类最多检索 250 个匹配，可分批显示。',
  名称: '名称',
  总结最小论证单元: '总结最小论证单元',
  设为焦点: '设为焦点',
  取消焦点: '取消焦点',
  '焦点已设置，完成宏观图构建后可按焦点更新。': '焦点已设置，完成宏观图构建后可按焦点更新。',
  '导入 Schema': '导入分类体系',
  '导出 Schema': '导出分类体系',
  'Schema 文件格式无效。': '分类体系文件格式无效。',
  'Schema 已导入。已有分类会保留；同名同编号分类已更新，冲突编号已自动分配。':
    '分类体系已导入。已有分类会保留；同名同编号分类已更新，冲突编号已自动分配。',
  切换图视图: '切换图视图',
  'Motif 图集': '论证模式图集',
  '按 Motif 查看当前文档中的匹配子图，点击小图返回主图定位。':
    '按论证模式查看当前文档中的匹配子图，点击小图返回主图定位。',
  '定位匹配 {n}': '定位匹配 {n}',
  暂无匹配子图: '暂无匹配子图',
  显示更多: '显示更多',
  '请先添加 Motif': '请先添加论证模式',
  正文: '正文',
  'Embedding 维度不一致，请使用同一个 embedding 模型重新索引': '向量维度不一致，请使用同一个向量模型重新索引',
  选择文档: '选择文档',
  重新读取源文件: '重新读取源文件',
  '检查 Markdown 的修改并重新加载文档': '检查标记文档的修改并重新加载文档',
  重置当前文档: '重置当前文档',
  '清除当前文章的标注、分析、缓存和任务；保留原文与当前 Schema':
    '清除当前文章的标注、分析、缓存和任务；保留原文与当前分类体系',
  '{0} 项人工标注': '{0} 项人工标注',
  'AI 论证分析': '智能论证分析',
  待分析: '待分析',
  规则预标注: '规则预标注',
  本地数据库与浏览器缓存: '本地数据库与浏览器缓存',
  浏览器缓存: '浏览器缓存',
  仅本地保存: '仅本地保存',
  已保存: '已保存',
  保存中: '保存中',
  '导入 Markdown 或标注 JSON': '导入标记文档或标注数据',
  导入文件: '导入文件',
  导出: '导出',
  '工作区 JSON': '工作区数据',
  'Agent 提示词': '智能体提示词',
  'Markdown 源文件': '标记文档源文件',
  工作区视图: '工作区视图',
  正在读取文档: '正在读取文档',
  重新加载: '重新加载',
  论证分析: '论证分析',
  构建宏观图: '构建宏观图',
  按Schema更新: '按分类体系更新',
  按Facet更新: '按分析切面更新',
  按焦点更新: '按焦点更新',
  '构建段落图、全量单元、属性与向量索引': '构建段落图、全量单元、属性与向量索引',
  '按当前 Schema 重分类已有节点和边': '按当前分类体系重新分类已有节点和关系',
  '更新当前 Semantic Facet': '更新当前语义分析切面',
  '选中论证单元后，召回候选并分析局部关系': '选中论证单元后，召回候选并分析局部关系',
  '正在提交任务…': '正在提交任务…',
  '等待执行…': '等待执行…',
  已完成: '已完成',
  已中断: '已中断',
  分析失败: '分析失败',
  '正在分析…': '正在分析…',
  '请重试任务。': '请重试任务。',
  宏观图与全局索引已构建: '宏观图与全局索引已构建',
  '仅更新：{name}': '仅更新：{name}',
  '，当前阶段 {0}': '，当前阶段 {0}',
  自定义拓扑: '自定义拓扑',
  收起交互面板: '收起交互面板',
  个匹配: '个匹配',
  清除拓扑筛选: '清除拓扑筛选',
  '检索 Facet 实体': '检索分析切面实体',
  '检索…': '检索…',
  '清除 Facet 检索': '清除分析切面检索',
  清除检索: '清除检索',
  新建实体类别: '新建实体类别',
  编辑实体类别: '编辑实体类别',
  '编辑 {0} · {1}': '编辑 {0} · {1}',
  语义兴趣: '语义兴趣',
  结构化属性: '结构化属性',
  '{0} 个语义匹配单元': '{0} 个语义匹配单元',
  '{0} 次出现，{1} 个论证单元': '{0} 次出现，{1} 个论证单元',
  无匹配: '无匹配',
  暂无实体: '暂无实体',
  清除实体筛选: '清除实体筛选',
  新建节点类型: '新建节点类型',
  编辑节点类型: '编辑节点类型',
  新建关系类型: '新建关系类型',
  编辑关系类型: '编辑关系类型',
  新建拓扑: '新建拓扑',
  编辑拓扑: '编辑拓扑',
  中文名: '中文名',
  英文名: '英文名',
  样式: '样式',
  '显示{0}类型：{1}': '显示{0}类型：{1}',
  节点: '节点',
  关系: '关系',
  段落: '段落',
  检索源文本: '检索源文本',
  '检索文本…': '检索文本…',
  句: '句',
  '标注段落 {0}': '标注段落 {0}',
  没有匹配的段落: '没有匹配的段落',
  展开交互面板: '展开交互面板',
  添加关系: '添加关系',
  全部折叠: '全部折叠',
  全部展开: '全部展开',
  适应画布: '适应画布',
  章节: '章节',
  论证单元: '论证单元',
  条关系: '条关系',
  历史论证图: '历史论证图',
  '{0} 段落节点': '{0} 段落节点',
  折叠: '折叠',
  展开: '展开',
  个论证单元: '个论证单元',
  '{0} {1}关系': '{0} {1}关系',
  '{0} 论证单元': '{0} 论证单元',
  重试: '重试',
  暂无论证段落: '暂无论证段落',
  缩小: '缩小',
  放大: '放大',
  段落关系: '段落关系',
  单元关系: '单元关系',
  文章叙述顺序: '文章叙述顺序',
  暂停叙述: '暂停叙述',
  播放叙述顺序: '播放叙述顺序',
  暂停: '暂停',
  按文章顺序播放: '按文章顺序播放',
  上一个段落: '上一个段落',
  下一个段落: '下一个段落',
  文章叙述进度: '文章叙述进度',
  '{0}，第 {1} / {2} 段': '{0}，第 {1} / {2} 段',
  暂无段落: '暂无段落',
  引言: '引言',
  序: '序',
  清除时间筛选: '清除时间筛选',
  时间轴: '时间轴',
  结束年份: '结束年份',
  开始年份: '开始年份',
  '{0} 个论证单元没有可识别的时间': '{0} 个论证单元没有可识别的时间',
  未定年: '未定年',
  暂无时间: '暂无时间',
  拓扑名称: '拓扑名称',
  定义: '定义',
  描述这种论证模式的含义: '描述这种论证模式的含义',
  节点数: '节点数',
  关系类型: '关系类型',
  不限: '不限',
  '关系 {0} 起点': '关系 {0} 起点',
  '关系 {0} 终点': '关系 {0} 终点',
  删除边: '删除边',
  添加边: '添加边',
  支撑方式: '支撑方式',
  联合支撑: '联合支撑',
  独立支撑: '独立支撑',
  例证支撑: '例证支撑',
  类别名称: '类别名称',
  由英文名生成: '由英文名生成',
  'Facet 机制': '分析切面机制',
  'Attribute · 结构化属性': '结构化属性',
  'Semantic · 语义兴趣': '语义兴趣',
  提取词表: '提取词表',
  '可选，以逗号分隔；Agent 可按定义提取': '可选，以逗号分隔；智能体可按定义提取',
  相似度阈值: '相似度阈值',
  最多匹配单元: '最多匹配单元',
  '对语义召回结果使用 LLM 复核': '使用大语言模型复核语义召回结果',
  颜色: '颜色',
  类型颜色: '类型颜色',
  十六进制颜色: '十六进制颜色',
  线型: '线型',
  实线: '实线',
  虚线: '虚线',
  点线: '点线',
  '工作区中有 {count} 处引用此分类。请选择替代分类，原有节点、边和引用内容会保留。':
    '工作区中有 {count} 处引用此分类。请选择替代分类，原有节点、边和引用内容会保留。',
  '至少保留一个{kind}类型；可先新增分类再删除。': '至少保留一个{kind}类型；可先新增分类再删除。',
  替代分类: '替代分类',
  请选择分类: '请选择分类',
  替换并删除: '替换并删除',
  删除分类: '删除分类',
  取消: '取消',
  保存: '保存',
  层级: '层级',
  起点: '起点',
  选择起点: '选择起点',
  终点: '终点',
  选择终点: '选择终点',
  '联合支撑组 ID': '联合支撑组编号',
  可留空: '可留空',
  显示摘要: '显示摘要',
  '节点旁显示的简短标签，最多 20 字': '节点旁显示的简短标签，最多 20 字',
  '段落摘要（用于分类与关系分析）': '段落摘要（用于分类与关系分析）',
  论证表示: '论证表示',
  论证类型: '论证类型',
  起始句: '起始句',
  结束句: '结束句',
  分析依据与来源: '分析依据与来源',
  '核性：': '核性：',
  '类型：': '类型：',
  '段落摘要引用（非原文引用）': '段落摘要引用（非原文引用）',
  原文引用: '原文引用',
  '原文依据：': '原文依据：',
  '篇章关系：': '篇章关系：',
  标注备注: '标注备注',
  删除关系: '删除关系',
  保存标注: '保存标注',
  关闭: '关闭',
  新建关系: '新建关系',
  编辑关系: '编辑关系',
  论证单元标注: '论证单元标注',
  段落标注: '段落标注',
  '请填写名称。': '请填写名称。',
  '请添加有效关系，避免自环与重复边。': '请添加有效关系，避免自环与重复边。',
  '所有节点需连成一个拓扑。': '所有节点需连成一个拓扑。',
  '请填写定义。': '请填写定义。',
  '请填写英文名。': '请填写英文名。',
  'ID 需以小写字母开头，只包含字母、数字和下划线。': '编号需以小写字母开头，只包含字母、数字和下划线。',
  '这个 ID 已存在。': '这个编号已存在。',
  '请选择两个不同的端点。': '请选择两个不同的端点。',
  '这条关系已存在。': '这条关系已存在。',
  '结束句不能在起始句之前。': '结束句不能在起始句之前。',
  '分类不存在。': '分类不存在。',
  '至少保留一个分类。': '至少保留一个分类。',
  '请选择有效的替代分类。': '请选择有效的替代分类。',
  后端请求失败: '后端请求失败',
  '章节轮廓布局未能收敛。': '章节轮廓布局未能收敛。',
  '本地修改已恢复，等待同步。': '本地修改已恢复，等待同步。',
  '数据库与本地标注均有变化。本地修改已保留，可导出工作区，或重置当前文档后按当前 Schema 重新构建。':
    '数据库与本地标注均有变化。本地修改已保留，可导出工作区，或重置当前文档后按当前分类体系重新构建。',
  '请先启动本地后端：npm run backend': '请先启动本地后端服务。',
  '分析未完成，可再次点击对应任务按钮重试。': '分析未完成，可再次点击对应任务按钮重试。',
  '读取分析进度失败，正在重新连接。': '读取分析进度失败，正在重新连接。',
  '浏览器存储空间不足，请导出工作区。': '浏览器存储空间不足，请导出工作区。',
  'Schema 格式无效。': '分类体系格式无效。',
  '关系线型无效。': '关系线型无效。',
  'Facet 格式无效。': '分析切面格式无效。',
  'Motif 格式无效。': '论证模式格式无效。',
  '本地缓存不可用，已加载源文件。': '本地缓存不可用，已加载源文件。',
  '暂时无法检查 Markdown 源文件，当前显示已保存的版本。':
    '暂时无法检查标记文档源文件，当前显示已保存的版本。',
  'Markdown 源文件已变化，正在进行的分析仍使用原版本。任务结束后可重新读取源文件。':
    '标记文档源文件已变化，正在进行的分析仍使用原版本。任务结束后可重新读取源文件。',
  'Markdown 源文件已变化。为保留已有分析或标注，当前显示已保存的版本；可导出工作区备份，再通过“导入文件”将新版 Markdown 作为新文档分析。':
    '标记文档源文件已变化。为保留已有分析或标注，当前显示已保存的版本；可导出工作区备份，再通过“导入文件”将新版标记文档作为新文档分析。',
  '没有找到文档或 Markdown 源文件。': '没有找到文档或标记文档源文件。',
  '无法读取最新 Markdown，未重置文档。': '无法读取最新标记文档，未重置文档。',
  '当前文档已重置，保留当前 Schema。现在可重新构建宏观图。':
    '当前文档已重置，保留当前分类体系。现在可重新构建宏观图。',
  '后端尚未支持重置，请重启后端后重试。': '后端尚未支持重置，请重启后端后重试。',
  '分析任务进行中，完成后可编辑。': '分析任务进行中，完成后可编辑。',
  'Schema 已保存，后续分析使用新定义。': '分类体系已保存，后续分析使用新定义。',
  '分析任务进行中，完成后可删除分类。': '分析任务进行中，完成后可删除分类。',
  '分类已删除，后续分析使用更新后的 Schema。': '分类已删除，后续分析使用更新后的分类体系。',
  标注已保存: '标注已保存',
  '文档 ID 不合法。': '文档编号不合法。',
  文档已导入: '文档已导入',
  '无法加载文件目录。': '无法加载文件目录。',
  'public/data 中没有 Markdown 文档。': '文档目录中没有标记文档。',
  '分析完成后可编辑 Schema。': '分析完成后可编辑分类体系。',
  '不是有效的 ArguLoom 文档。': '不是有效的本系统文档。',
  '编号必须有效且唯一。': '编号必须有效且唯一。',
  '句子编号重复或无效。': '句子编号重复或无效。',
  '论证单元引用了不存在的段落。': '论证单元引用了不存在的段落。',
  '文本块引用了不存在的段落。': '文本块引用了不存在的段落。',
  切换界面语言: '切换界面语言',
  总结各段并按摘要判断类型: '总结各段并按摘要判断类型',
  按滑动窗口分析段落关系: '按滑动窗口分析段落关系',
  切分段落内论证单元: '切分段落内论证单元',
  提取本地属性与时间: '提取本地属性与时间',
  建立全量单元向量: '建立全量单元向量',
  判断局部单元节点类型: '判断局部单元节点类型',
  判断局部单元关系: '判断局部单元关系',
  '按 Schema 更新已分类节点': '按分类体系更新已分类节点',
  '按 Schema 重分类已有边': '按分类体系重新分类已有关系',
  完成: '完成',
  排队: '排队',
  段落关系分析: '段落关系分析',
  提取属性: '提取属性',
  模型服务请求失败: '模型服务请求失败',
  '服务重启，可重试任务': '服务重启，可重试任务',
  '该文档正在分析，请等待任务结束后保存。': '该文档正在分析，请等待任务结束后保存。',
  '文档版本已变化，未覆盖数据库；请保留本地修改后同步。':
    '文档版本已变化，未覆盖数据库；请保留本地修改后同步。',
  '文档已更新，请重新发起分析。': '文档已更新，请重新发起分析。',
  '该文档已有进行中的任务。': '该文档已有进行中的任务。',
  该文档已有进行中的任务: '该文档已有进行中的任务',
  只允许本地工作区访问: '只允许本地工作区访问',
  '文档、节点或任务不存在': '文档、节点或任务不存在',
  '文档 ID 不匹配': '文档编号不匹配',
  '需要 source 和 id': '需要原文和编号',
  '重置需要 Markdown 原文': '重置需要标记文档原文',
  至少保留一种节点类型: '至少保留一种节点类型',
  仅可展开论证段落: '仅可展开论证段落',
  只能将论证单元设为分析焦点: '只能将论证单元设为分析焦点',
  '按 Facet 更新必须指定一个 Semantic Facet': '按分析切面更新必须指定一个语义分析切面',
  '宏观图与全局索引已完成，请使用对应更新任务': '宏观图与全局索引已完成，请使用对应更新任务',
  仅能重试失败或中断的任务: '仅能重试失败或中断的任务',
  '文档或 schema 已修改，请发起新任务': '文档或分类体系已修改，请发起新任务',
  '请先构建宏观图，完成全量单元、属性与向量索引': '请先构建宏观图，完成全量单元、属性与向量索引',
  '段落缺少 paragraph_representation，请先构建段落摘要': '段落缺少摘要表示，请先构建段落摘要',
  '单元索引缺失或原文范围已变化，请恢复有效索引后再分析焦点':
    '单元索引缺失或原文范围已变化，请恢复有效索引后再分析焦点',
  '缺少单元向量，请先完成全量索引': '缺少单元向量，请先完成全量索引',
  'Semantic facet 复核必须覆盖所有候选单元': '语义分析切面复核必须覆盖所有候选单元',
  'Semantic facet 复核缺少原文依据': '语义分析切面复核缺少原文依据',
  '聊天服务响应缺少 choices[0].message，请确认服务支持 Chat Completions 接口。':
    '聊天服务响应缺少返回消息，请确认服务支持聊天补全接口。',
  '聊天服务返回了无效的 tool_calls 格式。': '聊天服务返回了无效的工具调用格式。',
  '聊天服务返回的 message.content 必须是字符串。': '聊天服务返回的消息内容必须是字符串。',
  'Embedding 服务响应缺少 data[0].embedding，请确认地址和向量模型 ID。':
    '向量服务响应缺少向量数据，请确认地址和向量模型编号。',
  '该 agent 不允许工具调用': '该智能体不允许工具调用',
  'Facet 工具调用超出 5 轮限制': '分析切面工具调用超出五轮限制',
  '总结缺少有效的 display_label / paragraph_representation': '总结缺少有效的显示摘要或段落摘要',
  'node schema agent 返回未知类型': '节点分类智能体返回未知类型',
  'argu unit agent 的句子覆盖不完整、重叠或顺序错误': '论证单元智能体的句子覆盖不完整、重叠或顺序错误',
  '论证单元编号必须从 1 开始连续递增': '论证单元编号必须从 1 开始连续递增',
  'link schema agent 缺少 edges 数组': '关系分类智能体缺少关系数组',
  'link schema agent 返回了无效关系': '关系分类智能体返回了无效关系',
  'Embedding 服务返回无效向量': '向量服务返回无效向量',
  '时间提取必须返回 values 数组': '时间提取必须返回数值数组',
  时间属性值或引用不是文本中的连续片段: '时间属性值或引用不是文本中的连续片段',
  '关系重分类缺少 type': '关系重新分类缺少类型',
  关系重分类返回未知类型: '关系重分类返回未知类型',
  '关系 evidence 必须是非空数组，每项包含 node_id 和 quote':
    '关系依据必须是非空数组，每项包含节点编号和原文引用',
  '缺少 document 对象': '缺少文档对象',
  '图数据必须包含 paragraphs/units/edges/chapters/blocks 数组':
    '图数据必须包含段落、单元、关系、章节和文本块数组',
  '节点/关系 schema 定义或颜色无效': '节点或关系分类定义、颜色无效',
  关系线型无效: '关系线型无效',
  'Facet 需要有效机制和定义': '分析切面需要有效机制和定义',
  '语义 Facet 阈值需在 0–1，数量需在 1–100': '语义分析切面阈值需在零到一之间，数量需在一到一百之间',
  文档格式无效: '文档格式无效',
  '图 ID 重复': '图元素编号重复',
  段落引用不存在的章节: '段落引用不存在的章节',
  段落类型或句子内容无效: '段落类型或句子内容无效',
  句子编号重复: '句子编号重复',
  单元必须无重叠地完整覆盖段落: '单元必须无重叠地完整覆盖段落',
  已展开段落缺少论证单元: '已展开段落缺少论证单元',
  '论证单元的段落/类型无效': '论证单元的段落/类型无效',
  论证单元必须引用连续句子: '论证单元必须引用连续句子',
  '关系端点、层级或类型无效': '关系端点、层级或类型无效',
  文本块引用不存在的段落: '文本块引用不存在的段落',
  'Motif 需包含 2–6 个节点及有效边': '论证模式需包含二至六个节点及有效关系',
  'Motif 边无效': '论证模式关系无效',
  文本: '文本',
  原文: '原文',
  论证模式: '论证模式',
  拓扑结构: '拓扑结构',
  分析切面: '分析切面',
  '{0} 个实体': '{0} 个实体',
  分类体系: '分类体系',
  本体定义: '本体定义',
  论证图: '论证图',
  论证地图: '论证地图',
  图视图: '图',
  图集视图: '图集',
  焦点: '焦点',
  语义: '语义',
  实体: '实体',
  时间: '时间',
  '{0} 句': '{0} 句',
  '分类体系版本 {0}': '分类体系版本 {0}',
  工作区: '工作区',
  新建: '新建',
  '计数：段落': '{count} 个段落',
  '计数：章节': '{count} 个章节',
  '计数：论证单元': '{count} 个论证单元',
  '计数：关系': '{count} 条关系',
  '计数：匹配': '{count} 个匹配',
  '计数：句子': '{count} 句',
  公元前年份: '前{year}',
}
